import { render, staticRenderFns } from "./sale-create-goods.vue?vue&type=template&id=455ec0e0&"
import script from "./sale-create-goods.ts?vue&type=script&lang=ts&"
export * from "./sale-create-goods.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports